import React from 'react'

export default class DetailsForm extends React.Component{



  render(){
    let { completeQuiz, companyDetail, handleChangeTextarea } = this.props
    let  frontpageAcf = this.props.frontpageObject.acf
    return(
      <>
      
          <div className="tab-content active level1" id="tab1">
            <form className="form form-ajax tab-content__form" onSubmit={(e) => completeQuiz(e, 0, true, false)}>
              <div className="form__title form__title_marg form__title_center"
                dangerouslySetInnerHTML={{__html: frontpageAcf.general_question.general_title}} 
              />
              <div className="form__line">
                <div className="form__label form__label_marg form__label_center form__label_tooltip">
                  <span className="tooltip">
                    <span className="tooltip__icon">?</span>
                    <div className="tooltip__info tooltip__info_top"
                      dangerouslySetInnerHTML={{__html: frontpageAcf.general_question.hint}} 
                    />
                  </span>
                  <div
                    dangerouslySetInnerHTML={{__html: frontpageAcf.general_question.description}} 
                  />
                </div>

                <textarea 
                  name="company_detail" 
                  value={ companyDetail } 
                  onChange={(e) => handleChangeTextarea(e.target.value)}
                  className="form__textarea form__textarea_center"
                />
              </div>

              <div className="form-submit form-submit_center row">
                {
                  companyDetail.length > 0 ?                   
                    <button type="submit" className="form-submit-btn"
                      dangerouslySetInnerHTML={{__html: '<span>' + frontpageAcf.general_question.button_text + '</span>'}} 
                    />
                  : ''
                }
              </div>
            </form>

          </div>

      </>
    )
  }
}